import { Icon, ICONS } from 'components/Icon';
import { Pressable } from 'components/Pressable';
import { Image } from 'expo-image';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { useDispatch } from 'react-redux';
import { doSetImagePreview } from 'store/actions';
import { selectUserAvatar } from 'store/auth/selectors';

interface AnchorProps {
  previewOnPress?: boolean;
  size?: number;
  style?: StyleProp<ViewStyle>;
}

const SIZE = 36;

export const UserAvatar: React.FC<AnchorProps> = ({
  previewOnPress = true,
  size = SIZE,
  style,
}) => {
  const dispatch = useDispatch();
  const avatar = useSelector(selectUserAvatar);

  const handlePreview = () => {
    if (avatar) {
      dispatch(
        doSetImagePreview({
          image: avatar,
        }),
      );
    }
  };

  return (
    <Pressable
      onPress={previewOnPress && avatar ? handlePreview : undefined}
      style={[
        {
          backgroundColor: '#999999',
          borderRadius: size / 2,
          height: size,
          overflow: 'hidden',
          width: size,
          alignItems: 'center',
          justifyContent: 'center',
        },
        style,
      ]}
    >
      {avatar ? (
        <Image
          source={{ uri: avatar }}
          style={{ borderRadius: size / 2, height: size, width: size }}
          contentFit="contain"
        />
      ) : (
        <Icon source={ICONS.CircleUserCustom} size={size} color="#ffffff" />
      )}
    </Pressable>
  );
};
